import React from 'react';
import { ButtonProps } from '@/types';

// Reusable button component with variants matching our design - optimized with React.memo
export const Button: React.FC<ButtonProps> = React.memo(
  ({
    children,
    variant = 'primary',
    size = 'md',
    onClick,
    className = '',
    disabled = false,
    type = 'button',
  }) => {
    // Base styles that all buttons share
    const baseStyles =
      'font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2';

    // Variant styles - matching our existing design
    const variantStyles = {
      primary: 'bg-blue-600 hover:bg-blue-700 text-white',
      secondary:
        'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white',
      outline: 'border-2 border-blue-600 hover:bg-blue-600 text-blue-600 hover:text-white',
    };

    // Size styles
    const sizeStyles = {
      sm: 'px-4 py-2 text-sm',
      md: 'px-8 py-3',
      lg: 'px-10 py-4 text-lg',
    };

    // Disabled styles
    const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed hover:scale-100' : '';

    return (
      <button
        type={type}
        onClick={!disabled ? onClick : undefined}
        className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${className}`}
        disabled={disabled}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';
